import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import Timer from './Timer';
import VMNav from '../components/VMNav';
import Loader from '../components/Loader';
import getLink1 from '../images/get-yt-link-1.jpg'
import getLink2 from '../images/get-yt-link-2.jpg'
import api from '../helpers/ApiClient';
import gifIcon from '../images/gif-icon.svg'

class Recorder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recording: false,
      streaming: true,
      time: 0,
      errorMsg: '',
      recorderError: false,
      youtube: false,
      youtube_link: '',
      cameraOptions: [],
      gifMode: false,
      gifs: [],
      gifSearchTerm: 'Birthday'
    }
  }

  componentDidMount() {

    const { type } = this.props;

    if(type !== 'youtube'){
      const checkNav = setInterval(() => {
        if(navigator.onLine){
          this.initRecorder();
          clearInterval(checkNav)
        }
      }, 500)
    } else {
      this.setState({ youtube: true })
    }

    window.parent.postMessage({ vmRecording: true }, "https://giftr.my");

  }

  componentWillUnmount(){
    window.parent.postMessage({ vmRecording: false }, "https://giftr.my");

    const { streamObj } = this.state;
    const { showSkip } = this.props;

    if(streamObj && streamObj.active){
      this.stopStreams();
    }
    showSkip(true);
  }

  componentDidUpdate(prevProps, prevState){
    const { showSkip, skipVisible } = this.props;
    const { outputMedia, recording, restrict } = this.state;

    if(outputMedia && !recording && !restrict && skipVisible !== false){
      showSkip(false);
    }
  }

  initRecorder = () => {
    const { mediaType } = this.props;
    const input = this.inputRef;
    const audioVisualizer = this.visualizerRef;

    navigator.mediaDevices.getUserMedia(mediaType)
      .then(streamObj => {

        if(input || audioVisualizer){
          if(mediaType.video){
            input.srcObject = streamObj
          } else {
            this.visualizeAudio(streamObj)
          }
          let mediaRecorder = this.initMediaRecorder(streamObj)

          this.setState({
            streamObj,
            mediaRecorder,
            chunks: []
          })
        }

        return navigator.mediaDevices.enumerateDevices()
      })
      .then(mediaDevices => {
        let count = 1;
        let options = []

        mediaDevices.forEach(mediaDevice => {
          if (mediaDevice.kind === 'videoinput') {
            let option = {}
            option.value = mediaDevice.deviceId;
            option.label = mediaDevice.label || `Camera ${count++}`;
            options.push(option)
          }
        });

        this.setState({ cameraOptions: options })
      })
      .catch(err => {
        console.log(err);
        let errorMsg

        switch(err.name){
          case 'NotAllowedError':
            errorMsg = 'Camera or microphone access denied'
            break;
          case 'NotFoundError':
          case 'NotReadableError':
            errorMsg = 'Camera or microphone not found'
            break;
          default:
            errorMsg = 'Unknown error occured'
            break;
        }

        this.setState({ recorderError: true, errorMsg, restrict: true })
      })
  }

  stopMediaTracks(stream) {
    stream.getTracks().forEach(track => {
      track.stop();
    });
  }

  initMediaRecorder(streamObj) {
    let mediaRecorder = new MediaRecorder(streamObj)

    mediaRecorder.ondataavailable = e => {
      this.setState({
        chunks: [...this.state.chunks, e.data]
      })
    }

    mediaRecorder.onstop = () => {
      const { mediaType: { video } } = this.props;
      let blob = new Blob(this.state.chunks, {'type': video ? 'video/mp4' : 'audio/mp3'});
      let blobUrl = window.URL.createObjectURL(blob)

      this.outputRef.src = blobUrl

      const { streamObj } = this.state;
      streamObj.getTracks().forEach(track => track.enabled = false)

      this.setState({
        chunks: [],
        outputMedia: blob,
        recording: false,
        streaming: false
      });
    }

    return mediaRecorder
  }

  handleOnCameraChange = e => {
    const { streamObj } = this.state;
    let deviceId = e.target.value
    const input = this.inputRef;

    if(streamObj){
      this.stopMediaTracks(streamObj);
    }

    const videoConstraints = {};
    videoConstraints.deviceId = { exact: deviceId, height: { max: '720' } };
    const constraints = {
      video: videoConstraints,
      audio: true
    };

    navigator.mediaDevices.getUserMedia(constraints).then(stream => {
      input.srcObject = stream
      let mediaRecorder = this.initMediaRecorder(stream)
      this.setState({ streamObj: stream, mediaRecorder})
    })
  }

  // fix media duration Infinity
  outputOnLoad = e => {
    const vid = e.target
    const { outputMedia } = this.state;
    const checkMedia = this.checkMedia;

    if (vid.duration == Infinity) {
      vid.currentTime = 1e101;
      vid.ontimeupdate = function() {
        this.ontimeupdate = () => {
          return;
        }
        vid.currentTime = 0;
        checkMedia(outputMedia);
        return;
      }
    }
  }

  checkMedia = file => {
    const { mediaType, type } = this.props;
    let error = '';

    if(file && file.size > 20000000){
      error = error.concat(` ${mediaType.video ? 'Video' : 'Audio'} size is too big.`)
    }

    if(type !== 'image' && this.outputRef.duration > 120){
      error = error.concat(` ${mediaType.video ? 'Video' : 'Audio'} length is too long.`)
    }

    this.setState({
      errorMsg: error,
      restrict: error ? true : false
    })
  }

  visualizeAudio = stream => {
    let { audioCtx } = this.state
    const canvas = this.visualizerRef
    canvas.width = canvas.offsetWidth
    canvas.height = canvas.offsetHeight
    const canvasCtx = canvas.getContext('2d')

    if(!audioCtx) {
      audioCtx = new AudioContext();
    }

    const source = audioCtx.createMediaStreamSource(stream);

    const analyser = audioCtx.createAnalyser();
    analyser.fftSize = 2048;
    const bufferLength = analyser.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);

    source.connect(analyser);

    this.setState({ audioCtx })

    draw()

    function draw() {
      const WIDTH = canvas.width
      const HEIGHT = canvas.height;

      requestAnimationFrame(draw);

      analyser.getByteTimeDomainData(dataArray);

      canvasCtx.fillStyle = '#ffffff';
      canvasCtx.fillRect(0, 0, WIDTH, HEIGHT);

      canvasCtx.lineWidth = 5;
      canvasCtx.strokeStyle = '#81d8d0';

      canvasCtx.beginPath();

      let sliceWidth = WIDTH * 1.0 / bufferLength;
      let x = 0;


      for(let i = 0; i < bufferLength; i++) {

        let v = dataArray[i] / 128.0;
        let y = v * HEIGHT/2;

        if(i === 0) {
          canvasCtx.moveTo(x, y);
        } else {
          canvasCtx.lineTo(x, y);
        }

        x += sliceWidth;
      }

      canvasCtx.lineTo(canvas.width, canvas.height/2);
      canvasCtx.stroke();

    }
  }

  takePicture = () => {

    const canvas = this.imageCanvasRef
    const input = this.inputRef
    canvas.width = input.videoWidth
    canvas.height = input.videoHeight

    const canvasCtx = canvas.getContext('2d')
    canvasCtx.drawImage(input, 0, 0, input.videoWidth, input.videoHeight, 0, 0, input.videoWidth, input.videoHeight);
    let dataURL = canvas.toDataURL("image/png");

    let blob = this.dataURLtoBlob(dataURL)
    this.setState({ outputMedia: blob, outpuDataUrl: dataURL })

    const { streamObj } = this.state;

    if(streamObj && streamObj.active){
      this.stopStreams();
    }
  }

  retakePicture = () => {

    this.initRecorder();

    this.setState({ outputMedia: undefined, outpuDataUrl: undefined })
  }

  dataURLtoBlob =(dataurl) => {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {type:mime});
  }

  startRecord = () => {
    const { mediaRecorder, streamObj } = this.state;

    if(mediaRecorder && streamObj){
      this.setState({
        errorMsg: '',
        recording: true,
        streaming: true
      }, () => {
        const { mediaType } = this.props;

        if(mediaType.video){
          this.inputRef.srcObject = streamObj
        } else {
          this.visualizeAudio(streamObj)
        }

        streamObj.getTracks().forEach(track => track.enabled = true)

        this.setState({ time: 0 })
        mediaRecorder.start();

        this.outputRef.pause();

        this.setState({
          interval: setInterval(() => {
            this.setState({ time: this.state.time + 1000 })
          }, 1000),
        })
      })
    }
  }

  stopRecord = () => {
    const { mediaRecorder, interval } = this.state;

    mediaRecorder.stop();

    clearInterval(interval)
  }

  stopStreams = () => {
    const { streamObj, audioCtx } = this.state;

    streamObj.getTracks().forEach(track => track.stop());
    if(audioCtx && audioCtx.state === 'running'){
      audioCtx.close()
    }
  }

  doneRecord = () => {
    const { outputMedia, youtube, youtube_link } = this.state;
    const { returnMedia } = this.props;

    returnMedia(youtube ? youtube_link : outputMedia);
  }

  onDrop = file => {

    const {type} = this.props

    if(file && file.length > 0){
      this.setState({
        errorMsg: ''
      }, () => {
        this.checkMedia(file[0]);

        if(type !== 'image'){
          this.outputRef.src = file[0].preview

          this.setState({
            outputMedia: file[0],
            recording: false,
            streaming: false,
          })
        } else {
          this.setState({
            outputMedia: file[0],
            outpuDataUrl: URL.createObjectURL(file[0])
          })
        }

        this.stopStreams();
      })
    }
  }

  handleYTLink = e => {
    let link;
    if(e.type === 'click'){
      link = this.state.youtube_link;
    } else if(e.key === "Enter"){
      link = e.target.value
    }

    if(!link){
      return
    }

    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
    var match = link.match(regExp);
    if (match && match[2].length == 11) {
      this.setState({
        ytError: '',
        outputMedia: true,
        youtube_link: `https://www.youtube.com/embed/${match[2]}`
      });
    } else {
      this.setState({ ytError: 'Invalid link' })
    }
  }

  resetYT = () => {
    this.setState({
      outputMedia: null,
      youtube_link: ''
    })
  }

  getGif = async () => {

    this.stopStreams();

    const { gifSearchTerm } = this.state;

    this.setState({ gifs: [], gifMode: true })

    let result = await api(`/api/gif/${gifSearchTerm}`, {
      method: 'GET',
      headers: {
          'Content-Type': 'application/json',
      }
    })

    this.setState({ gifs: result, gifMode: true })
  }

  handleCancelGif = () => {
    this.setState({ gifMode: false, gifs: [] })
    this.initRecorder();
  }

  handleTermChange = e => {
    this.setState({ gifSearchTerm: e.target.value })
  }

  handleOnGifClick = gif => {
    this.setState({
      outputMedia: gif,
      outpuDataUrl: gif,
      gifMode: false,
      gifs: []
    })

    //URL.createObjectURL(file[0])
  }

  render() {
    const { mediaType, prompt, back, skip, skipVisible, type } = this.props;
    const { streamObj, mediaRecorder, recording, streaming, outputMedia, uploadingFile, time, restrict, errorMsg, recorderError, youtube, youtube_link, ytError, cameraOptions, outpuDataUrl, gifs, gifMode } = this.state;

    let acceptMediaType = ""

    if(type === "video"){
      acceptMediaType = "video/*, .mkv"
    } else if(type === "image"){
      acceptMediaType = "image/*"
    } else {
      acceptMediaType = "audio/*"
    }

    return (
      <div className="flex-column recorder-container vm-mobile-layout" style={{flexGrow: '1', alignItems: 'center' }}>
        <VMNav showBack={true} showSkip={skipVisible} type={type} showSubmit={!errorMsg && outputMedia && !recording && !restrict} back={back} skip={skip} submit={this.doneRecord}/>
        <div className="flex-column" style={{
          width: '100%',
          alignItems: 'center',
          flexGrow: '1',
          transition: 'all 0.5s'
        }}>
        {
          errorMsg &&
            <div className="recorder-content">
              <div className="recorder-error">
                <img style={{height: '3rem', margin: '0 5px'}} src="error-icon.svg"/>
                {errorMsg}
              </div>
            </div>
        }
        {
          !streamObj && !mediaRecorder && !youtube && !recorderError &&
            <Loader style={{margin: 'auto'}} />
        }
        {
          !errorMsg &&
            ( type === 'image' &&
              <div className="recorder-content" style={{position: 'relative'}}>
                <div hidden={!gifMode}>
                  <input className="vm-search-field" name="term" placeholder="Search for a GIF (Eg. Birthday)" type="text" onChange={this.handleTermChange}/>
                  <Button className="btn-virtual-message" style={{marginTop: '-5px', marginRight: '10px'}}onClick={this.getGif}>Search</Button>
                  <Button className="btn-virtual-message" style={{marginTop: '-5px'}}onClick={this.handleCancelGif}>Cancel</Button>
                </div>
                <div className="vm-mobile-layout vm-gif-container">
                  {
                    gifs.map((gif, index) => {
                      return (
                        <img className="vm-gif" src={gif.url} key={index} onClick={() => { this.handleOnGifClick(gif.url) }}/>
                      )
                    })
                  }
                </div>
                <video className="recorder-video" hidden={outputMedia || gifMode} ref={video => {this.inputRef = video}} onLoadedMetadata={e => e.target.play()} muted playsInline></video>
                <canvas hidden ref={imageCanvas => {this.imageCanvasRef = imageCanvas}}></canvas>
                <img className="recorder-video" hidden={!outputMedia || gifMode} src={outpuDataUrl}/>
              </div> ) ||
            ( type === 'video' &&
              <div className="recorder-content" style={{position: 'relative'}}>
                <video className={`recorder-video`} hidden={streaming} ref={video => {this.outputRef = video}} onLoadedMetadata={e => this.outputOnLoad(e)} controls playsInline></video>
                <video className={`recorder-video`} hidden={!streaming} ref={video => {this.inputRef = video}} onLoadedMetadata={e => e.target.play()} muted playsInline></video>
              </div> ) ||
            ( type === 'audio' &&
              <div className="recorder-content" style={{position: 'relative'}}>
                <canvas style={{height: '100%', width: '100%'}} className={`${!streaming ? 'hidden' : ''}`} ref={visualizer => {this.visualizerRef = visualizer}}></canvas>
                <audio className={`recorder-video ${streaming ? 'hidden' : ''}`} ref={audio => {this.outputRef = audio}} onLoadedMetadata={e => this.outputOnLoad(e)} controls={true} style={{height: '50%'}}></audio>
              </div> ) ||
            ( type === 'youtube' &&
              <div className="recorder-content" style={{position: 'relative'}}>
                {
                  outputMedia ?
                    <iframe className="vm-youtube-preview" src={youtube_link} />
                  :
                  <div style={{display: 'flex', flexGrow: '1', width: '100%', justifyContent: 'center', height: '100%'}}>
                    <div className='yt-link'>
                      <span style={{fontSize: '18px'}}>Paste YouTube link here</span>
                      <div style={{width: '100%', position: 'relative'}}>
                      <input
                        required
                        onChange={e => this.setState({ youtube_link: e.target.value })}
                        value={youtube_link}
                        onKeyPress={this.handleYTLink}
                        style={{margin: 'auto', width: '60%', textAlign: 'center', border: 'none', backgroundColor: '#f1f1f1', boxShadow: 'none'}}
                        type="text"
                        className="form-control input-lg"
                        autoFocus
                      />
                      {
                        ytError &&
                          <span style={{fontSize: '18px', position: 'absolute', top: '100%', left: '50%', transform: 'translateX(-50%)', color: '#d84141'}}>{ytError}</span>
                      }
                    </div>
                      <div className='yt-steps mt'>
                        <div className='yt-content'>
                          <div>
                          <img src={getLink1} />
                            <p style={{fontSize: '14px'}}>(A) Click/tap on share below the YouTube video</p>
                          </div>
                          <div>
                          <img src={getLink2} />
                            <p style={{fontSize: '14px'}}>(B) Click/tap on 'Copy Link' to get the link</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div> )
        }
        {
          youtube ?
            <div style={{textAlign: 'center', marginBottom: '5px'}}>
              <div className="vm-record-btns">
                {
                  outputMedia &&
                    <Button className="btn-virtual-message btn-vm-record" onClick={this.resetYT} disabled={recorderError}>
                      Change link
                    </Button>
                }
                {
                  !outputMedia &&
                    <Button className="btn-virtual-message btn-vm-record" onClick={this.handleYTLink} disabled={recorderError}>
                      Confirm
                    </Button>
                }
              </div>
              {
                prompt &&
                <p style={{fontSize: '12px', margin: '5px'}}>{prompt}</p>
              }
            </div>
            :
            <div hidden={gifMode} style={{textAlign: 'center', marginBottom: '20px'}}>
              {
                cameraOptions && cameraOptions.length > 1 &&
                <select disabled={recording} className="form-control" name="subject" onChange={this.handleOnCameraChange}>
                {
                  cameraOptions.map((option, index) => {
                    return <option key={index} value={option.value}>{option.label}</option>
                  })
                }
                </select>
              }
              <Timer className={ type==="image" ? 'hidden' : ''} time={time} />
              <div>
                <div className="vm-record-btns">
                  {
                    (type === "video" || type === "audio") &&
                    <div>
                    {
                      !recording ?
                        <Button className="btn-virtual-message btn-vm-record" onClick={this.startRecord} disabled={recorderError}>
                          <img className="vm-icons" src={mediaType.video ? 'video-icon.svg' : 'mic-icon.svg'}/>
                          {`${(outputMedia && !recorderError) ? 'Record again': 'Start recording'}`}
                        </Button>
                        :
                        <Button className="btn-virtual-message btn-vm-record recording" onClick={this.stopRecord} disabled={recorderError}>
                          <img className="vm-icons" src={mediaType.video ? 'video-icon.svg' : 'mic-icon.svg'}/>
                          Stop recording
                        </Button>
                    }
                    </div>
                  }
                  {
                    type === "image" &&
                    <div>
                      {
                        !outputMedia ?
                        <Button className="btn-virtual-message btn-vm-record" onClick={this.takePicture}>
                              <img className="vm-icons" src="video-icon.svg"/>
                              Take picture
                        </Button>
                        :
                        <Button className="btn-virtual-message btn-vm-record" onClick={this.retakePicture}>
                              <img className="vm-icons" src="video-icon.svg"/>
                              Retake picture
                        </Button>
                      }
                    </div>
                  }
                  {
                    type === "image" &&
                    <p style={{margin: '10px 20px'}}><strong>OR</strong></p>
                  }
                  {
                    type === "image" &&
                    <div>
                      <Button className="btn-virtual-message btn-vm-record" onClick={this.getGif}>
                        <img style={{height: '26px', margin: '-3px 10px -3px 0'}} className="vm-icons" src={gifIcon} alt="gif icon"/>
                        Add GIF
                      </Button>
                    </div>
                  }
                  <p style={{margin: '10px 20px'}}><strong>OR</strong></p>
                  <Dropzone
                    style={{}}
                    onDrop={this.onDrop}
                    multiple={false}
                    accept={ acceptMediaType }>
                    <Button className="btn-virtual-message btn-vm-record" disabled={uploadingFile}>
                      <img className="vm-icons" src="upload-icon.svg"/>
                      Upload {mediaType.video ? 'video/photo' : (type === "image" ? 'image/gif' : 'audio')}
                    </Button>
                  </Dropzone>
                </div>
                {
                  prompt &&
                    <p style={{fontSize: '12px', margin: '5px'}}>{prompt}</p>
                }
              </div>
            </div>
        }
        </div>
      </div>
    )
  }
}

export default Recorder;
